import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { AH_BORDER, AH_MUTED, AH_TEXT, AH_TRACK, AH_WHITE, cardShellSx } from "../theme";

const CARDS = [
  {
    key: "inProgress",
    title: "Total Assignments in Progress",
    caption: "In-Progress assessments currently evaluating infrastructure",
    icon: ShowChartIcon,
    tip: "Counts assignments in In-Progress status. Drafts are not included.",
  },
  {
    key: "approaching",
    title: "Approaching Completion",
    caption: "Assignments with target end dates within the next 14 days",
    icon: AccessTimeIcon,
    tip: "In-Progress assignments whose target completion is within 14 days.",
  },
  {
    key: "stale",
    title: "Stale / Inactive Assignments",
    caption: "Assessments with zero recent activity for 14 days or more",
    icon: WarningAmberIcon,
    tip: "In-Progress assignments with no activity in the last 14 days.",
    warn: true,
  },
];

const SummaryCards = ({ counts }) => (
  <Box sx={{ mb: 3 }}>
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.06em",
        color: AH_MUTED,
        textTransform: "uppercase",
        mb: 1.25,
      }}
    >
      Executive Summary
    </Typography>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" },
        gap: 1.5,
      }}
    >
      {CARDS.map((card) => {
        const Icon = card.icon;
        return (
          <Box key={card.key} sx={{ ...cardShellSx, p: 2.25, position: "relative" }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "10px",
                    backgroundColor: card.warn ? "#fff7ed" : AH_TRACK,
                    color: card.warn ? "#c2410c" : AH_TEXT,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon sx={{ fontSize: 20 }} />
                </Box>
                <Typography sx={{ fontSize: "1.75rem", fontWeight: 700, color: AH_TEXT, lineHeight: 1 }}>
                  {counts[card.key] ?? 0}
                </Typography>
              </Box>
              <Tooltip title={card.tip} placement="top">
                <Box
                  component="span"
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    border: `1px solid ${AH_BORDER}`,
                    color: AH_MUTED,
                    fontSize: 10,
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "default",
                    backgroundColor: AH_WHITE,
                  }}
                >
                  i
                </Box>
              </Tooltip>
            </Box>
            <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: AH_TEXT }}>
              {card.title}
            </Typography>
            <Typography sx={{ mt: 0.25, fontSize: "0.75rem", color: AH_MUTED, lineHeight: 1.45 }}>
              {card.caption}
            </Typography>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default SummaryCards;
